import { CometidoAgenteInmobiliariaEnum, type EditAgenteInmobiliariaModel, type CreateAgenteInmobiliariaModel, type DetailUsuarioModel, type DireccionModel } from '@api/api';

export class CreateAgenteInmobiliaria implements CreateAgenteInmobiliariaModel {

  Nombre: string = '';
  Apellidos: string = '';
  Email: string = '';
  Documento: string = '';
  Telefono: string = '';
  Direccion: DireccionModel = {
    CodigoPostal: null,
    Provincia: null,
    Municipio: null,
    TipoVia: null,
    NombreVia: null,
    Numero: null,
    Escalera: null,
    Piso: null,
    Puerta: null
  };
  IdEmpresaAgentes: string | null = null;
  IdCometido: CometidoAgenteInmobiliariaEnum = CometidoAgenteInmobiliariaEnum.Agente;
  IdsDelegacionInmobiliaria: string[] = [];

  constructor(data?: Partial<CreateAgenteInmobiliaria>) {
    Object.assign(this, data);
  }

  public createFromAgenteInmobiliariaDetail(usuario: DetailUsuarioModel): CreateAgenteInmobiliaria {
    Object.assign(this, usuario);
    return this;
  }
}

export class EditAgenteInmobiliaria extends CreateAgenteInmobiliaria implements EditAgenteInmobiliariaModel {
  Id: string = '';
  IdEmpresaInmobiliaria: string | null = null;

  constructor(data?: Partial<EditAgenteInmobiliaria>) {
    super(data);
  }
}